// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2jcj8","spinner":"styles-module__spinner___1p2eJ"};